import { Box, Grid, Paper, Typography } from '@mui/material';

interface Props {
  title: string;
  children: React.ReactNode;
  hasContainer?: boolean;
  containerVariant?: 'elevation' | 'outlined';
  containerElevation?: number;
}

const FormSubSection = ({
  title,
  children,
  hasContainer = true,
  containerVariant = 'outlined',
  containerElevation = 3
}: Props) => {
  if (hasContainer) {
    return (
      <Paper
        sx={{ p: 2 }}
        variant={containerVariant}
        elevation={containerVariant === 'elevation' ? containerElevation : 0}
      >
        <Typography variant="h2" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Grid container spacing={2} sx={{ my: 2 }}>
          {children}
        </Grid>
      </Paper>
    );
  }

  return (
    <Box sx={{ mb: 5 }}>
      <Typography variant="h2">{title}</Typography>
      <Grid container spacing={2} sx={{ my: 0 }}>
        {children}
      </Grid>
    </Box>
  );
};

export default FormSubSection;
